import { jsx } from '@emotion/react/jsx-runtime';

const Option = ({ cssOverrides, children, ...props }) => {
  return /* @__PURE__ */ jsx("option", { css: cssOverrides, ...props, children });
};

export { Option };
